import React, { Suspense } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { professionalAction } from "../../_actions";
import {
  Drawer,
  Button,
  Divider,
  PageHeader,
  Descriptions,
  message,
} from "antd";
import { GangDetectionForm } from "./gangDetection";
import { gangDetectionAction } from "../../_actions/gang.detection.actions";

const GangDetectionListTable = React.lazy(() =>
  import("./gangDetectionList").then((module) => ({
    default: module.GangDetectionListTable,
  }))
);

let columns = [];
let data = [];

class GangDetectionModule extends React.Component {
  constructor(props) {
    super(props);
  }
  state = {
    addGangDetectionModule: false,
    isUpdate: false,
    userFormEditData: [],
    resetFrom: false,
    userList: [],
    units: "",
    data: [],
    columns: [],
  };
  userForm = React.createRef();

  componentDidMount() {
    this.getActiveUnits();
    this.AllocatedGangDetectionModuleList();
  }

  onOpenAddVerificationDrawer = () => {
    this.setState({
      addGangDetectionModule: true,
      resetFrom: true,
    });
  };

  onCloseAddVerificationDrawer = () => {
    this.setState({
      addGangDetectionModule: false,
      resetFrom: false,
    });
  };

  getActiveUnits = () => {
    professionalAction
      .getActiveCities()
      .then((res) => {
        res &&
          res.text().then((response) => {
            let units = JSON.parse(response);
            this.setState({ units: units });
          });
      })
      .catch((err) => {});
  };

  AllocatedGangDetectionModuleList = () => {
    gangDetectionAction.AllocatedGangDetectionModuleList().then((res) => {
      res &&
        res.text().then((response) => {
          let result = JSON.parse(response);

          let columns1 =
            result &&
            result &&
            result.map((itemObj, index) => {
              return {
                ...itemObj,
              };
            });

          let tempObj = columns1.map((res, index) => {
            return {
              ...res,
            };
          });

          this.setState({
            data: tempObj,
          });
        });
    });
  };

  onFormFinish = (values) => {
    const currentDate = new Date();
    const durationYears = parseInt(this.props.values.subscription_duration);

    const expiryDate = new Date(
      currentDate.setFullYear(currentDate.getFullYear() + durationYears)
    )
      .toISOString()
      .split("T")[0];

    const requestData = {
      module_name: values.module_name,
      email: values.email,
      cityId: values.unitName,
      unit_name:
        this.state.units.find((unit) => unit.cityId === values.unitName)
          ?.city_name[0]?.City || "",
      plan: values.plan,
      subscription_duration: values.subscription_duration,
      expiry_date: expiryDate,
    };

    gangDetectionAction
      .AllocatedGangDetectionModule(requestData)
      .then((data) => {
        message.success("Successfully Submitted");
      })
      .catch((error) => {
        console.error("Error in saving verification allocation:", error);
      });
  };

  toggleActiveState = () => {
    this.setState((prevState) => ({
      addGangDetectionModule: !prevState.addGangDetectionModule,
    }));
  };

  render() {
    const { users } = this.props;
    const { user } = this.props;
    const { pc_cities, basicDistricts } = this.props;

    const roleFour = user && user.role === "4" ? "घटक" : "जिल्हा";

    return (
      <div className="col-md-6 col-md-offset-3">
        <div className="site-page-header-ghost-wrapper">
          <PageHeader
            ghost={false}
            onBack={false}
            title={user && user.userid}
            subTitle={
              user && user.role === "4" ? "( ADMIN )" : "( SUPER ADMIN )"
            }
            extra={[
              <Button
                type="primary"
                className="mb-4"
                onClick={this.onOpenAddVerificationDrawer}
              >
                नवीन जोडा
              </Button>,
            ]}
          >
            <Descriptions size="small" column={3}>
              <Descriptions.Item
                label={user && user.role === "8" ? "राज्य" : roleFour}
              >
                {user && user.role === "8"
                  ? "महाराष्ट्र"
                  : "महाराष्ट्र" +
                    " " +
                    "( " +
                    this.getCityName(user && user.cityId) +
                    " )"}
              </Descriptions.Item>
              <Descriptions.Item>
                <span style={{ fontSize: "25px", fontWeight: "600" }}>
                  Gang Detection tool
                </span>
              </Descriptions.Item>
            </Descriptions>
          </PageHeader>
        </div>

        <Divider />
        <Drawer
          title="नवीन जोडा"
          placement="right"
          width={720}
          closable={true}
          onClose={this.onCloseAddVerificationDrawer}
          visible={this.state.addGangDetectionModule}
          footer={
            <div
              style={{
                textAlign: "right",
              }}
            >
              <Button
                onClick={this.onCloseAddVerificationDrawer}
                style={{ marginRight: 8 }}
              >
                Cancel
              </Button>
              {/* {!this.state.isUpdate ? (
                <Button onClick={this.onFormFinish} type="primary">
                  Save
                </Button>
              ) : (
                <Button onClick={this.onUserFormUpdate} type="primary">
                  Update
                </Button>
              )} */}
            </div>
          }
        >
          <GangDetectionForm
            ref={this.userForm}
            user={user}
            data={this.state.data}
            units={this.state.units}
            addGangDetectionModule={this.state.addGangDetectionModule}
            toggleActive={this.toggleActiveState}
            cityData={pc_cities}
            districtData={basicDistricts}
            users={users}
            onFormFinish={this.onFormFinish}
            AllocatedGangDetectionModuleList={
              this.AllocatedGangDetectionModuleList
            }
          ></GangDetectionForm>
        </Drawer>
        <Suspense fallback={<div>Loading...</div>}>
          <GangDetectionListTable
            onEdituser={this.onEdituser}
            data={this.state.data}
            columns={columns}
            userRole={user}
          ></GangDetectionListTable>
        </Suspense>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { users, authentication, professionals } = state;
  const { user } = authentication;
  const { pc_cities, basicDistricts } = professionals;
  return {
    user,
    users,
    pc_cities,
    basicDistricts,
  };
}

const connectedGangDetectionModule =
  connect(mapStateToProps)(GangDetectionModule);
export { connectedGangDetectionModule as GangDetectionModule };
